import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { DeliveryWhereInput, PaginationInputType } from '@/gql/graphql';

// Fragments
import './fragments/estimateFragment';

export const getOrdersWithEstimation = async ({ where, pagination }: { where: DeliveryWhereInput; pagination: PaginationInputType }) => {
  const response = await queryExecute({
    query: graphql(`
      query GetOrdersWithEstimation($where: DeliveryWhereInput!, $pagination: PaginationInputType!) {
        getOrders(where: $where, pagination: $pagination) {
          count
          rows {
            id
            status
            paidStatus
            callerId
            orderId
            preferredPhoneNumber
            clientName
            operatorId
            scheduleId
            storeOrder {
              title
              storeGroup
              subtitle
              service
              estimate {
                ...EstimateFragment
              }
            }
          }
        }
      }
    `),
    variables: {
      where,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getOrders;
};
